import { useState, useEffect } from "react";

/**
 * Detects the user's inactivity (idle state).
 * @returns {boolean} isIdle
 */
export default function useIdleTimer() {
  const [isIdle, setIsIdle] = useState(false);
  const idleInterval = 1; // minutes interval to check if user is idle
  const inactiveTime = 10; // minutes to inactive time
  const eventTypes = ["mousemove", "keydown", "keyup", "click"];

  /**
   * Converts minutes to milliseconds.
   * @param minutes
   * @returns {number}
   */
  function minutesToMilliseconds(minutes) {
    return minutes * 60000;
  }

  /**
   * Updates the last activity timestamp to the current timestamp.
   * Saves the current timestamp to ISO format in localStorage.
   */
  const updateLastActivity = () => {
    const lastActivityTime = new Date().toISOString();
    localStorage.setItem("lastActivity", lastActivityTime);
  }

  /**
   * Checks the difference between the current time and the last activity time.
   * Determines if the user has been inactive for long enough to considered idle.
   */
  const resetTimer = () => {
    const currentTime = new Date();
    const lastActivityString = localStorage.getItem("lastActivity");
    if(lastActivityString) {
      const lastActivityTime = new Date(lastActivityString);
      const idleTime = currentTime - lastActivityTime;
      
      setIsIdle(idleTime >= minutesToMilliseconds(inactiveTime));
    } else {
      updateLastActivity();
    }
  }

  useEffect(() => {
    // Checks if user was idle prior to browser launch.
    resetTimer();
    
    // Add event listeners by type to update last activity
    eventTypes.forEach((event) =>
      window.addEventListener(event, updateLastActivity)
    );

    // Set initial last activity to now
    const interval = setInterval(
      resetTimer,
      minutesToMilliseconds(idleInterval)
    );

    // Clear interval and remove event listeners on cleanup
    return () => {
      clearInterval(interval);
      eventTypes.forEach((event) =>
        window.removeEventListener(event, updateLastActivity)
      );
    };
  }, []);

  return isIdle;
}
